import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import { Button } from "@material-tailwind/react";

import { animation, containerAnimation } from "../../utils/animation";

import { IoBagHandle, IoClose } from "react-icons/io5";
import { FiArrowUpRight } from "react-icons/fi";

import bestsellers from "../../data/bestsellers";

const wishlistItems = bestsellers.slice(0, 6);

const Wishlist = () => {
  return (
    <motion.section
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
      className="bg-greyBg bg-opacity-40 py-8 xl:py-14 lg:py-14"
    >
      <div className="container">
        <motion.div variants={animation} className="mb-6 xl:mb-10 lg:mb-10">
          <p className="text-sm font-source uppercase tracking-[0.3em] text-headerGrey">
            Wishlist
          </p>
          <div className="mt-3 flex flex-col xl:flex-row lg:flex-row xl:items-end lg:items-end xl:justify-between lg:justify-between gap-4">
            <div>
              <h1 className="text-3xl xl:text-4xl lg:text-4xl font-fraunces-bold tracking-tight text-black">
                Saved wholesale picks
              </h1>
              <p className="mt-2 text-base xl:text-lg lg:text-lg font-source text-headerGrey">
                Curate inventory ideas and move top sellers into your bag.
              </p>
            </div>
            <Link to="/shop" className="w-full xl:w-fit lg:w-fit">
              <Button className="w-full xl:w-fit lg:w-fit shadow-none hover:shadow-none text-base font-source font-semibold text-white normal-case flex items-center justify-center gap-2">
                Continue shopping
                <FiArrowUpRight className="w-5 h-5 text-white" />
              </Button>
            </Link>
          </div>
        </motion.div>

        <motion.div
          variants={animation}
          className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-5 xl:gap-10 lg:gap-10"
        >
          <div className="col-span-2 space-y-4">
            {wishlistItems.map((item) => (
              <div
                key={item.id}
                className="bg-white border border-greyBorder rounded-2xl p-5 shadow-sm flex flex-col xl:flex-row lg:flex-row gap-5"
              >
                <div className="w-full xl:w-[25%] lg:w-[25%] flex-shrink-0">
                  <div className="rounded-xl flex items-center justify-center">
                    <img
                      src={item.image}
                      className="w-3/4 h-36 object-contain"
                      alt={item.name}
                    />
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex flex-col xl:flex-row lg:flex-row xl:items-center lg:items-center xl:justify-between lg:justify-between gap-3">
                    <div>
                      <h3 className="text-xl font-fraunces-bold tracking-tight text-black">
                        {item.name}
                      </h3>
                      <p className="text-sm font-source text-headerGrey">
                        West Coast Imports
                      </p>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="text-sm font-source font-semibold text-logoYellow">
                        Wholesale pricing
                      </div>
                      <Button className="shadow-none hover:shadow-none p-2 hover:bg-black hover:bg-opacity-5 rounded-full bg-white border border-greyBorder">
                        <IoClose className="text-black w-4 h-4" />
                      </Button>
                    </div>
                  </div>

                  <div className="mt-4 flex flex-wrap gap-3">
                    <span className="px-3 py-1 rounded-full bg-greyBg text-xs font-source text-headerGrey">
                      UPC: {item.upc}
                    </span>
                  </div>

                  <div className="mt-5 flex flex-wrap gap-3">
                    <Button className="shadow-none hover:shadow-none bg-primary text-white text-sm font-source font-semibold normal-case rounded-full px-5 py-2 flex items-center gap-2">
                      <IoBagHandle className="w-4 h-4" />
                      Move to bag
                    </Button>
                    <Link to="/product-detail">
                      <Button className="shadow-none hover:shadow-none bg-white border border-greyBorder text-sm font-source font-semibold text-black normal-case rounded-full px-5 py-2">
                        View details
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="col-span-1">
            <div className="bg-white border border-greyBorder rounded-2xl p-6 shadow-sm sticky top-24">
              <h2 className="text-xl font-fraunces-bold tracking-tight text-black">
                Wishlist summary
              </h2>
              <p className="text-sm font-source text-headerGrey">
                Keep track of what you plan to reorder next.
              </p>

              <div className="mt-5 space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-source text-headerGrey">
                    Items saved
                  </span>
                  <span className="text-lg font-source font-bold text-black">
                    {wishlistItems.length}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-source text-headerGrey">
                    Estimated order value
                  </span>
                  <span className="text-lg font-source font-bold text-black">
                    —
                  </span>
                </div>
              </div>

              <div className="mt-6 bg-greyBg bg-opacity-60 rounded-xl p-4 border border-greyBorder">
                <h4 className="text-base font-source font-semibold text-black">
                  Pro tip
                </h4>
                <p className="mt-2 text-sm font-source text-headerGrey">
                  Bundle top sellers to unlock priority logistics and faster
                  restocks.
                </p>
              </div>

              <div className="mt-6 flex flex-col gap-3">
                <Button className="shadow-none hover:shadow-none bg-logoYellow text-white text-sm font-source font-semibold normal-case rounded-full px-5 py-2">
                  Move all to bag
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Wishlist;
